import { useMemo } from 'react'
import { toast } from 'sonner'
import type { TerminalInfo } from '../../terminals/types'
import { ActionDropdown } from '@shared/components/ui/action-dropdown/ActionDropdown'
import { Button } from '@shared/components/ui/button'
import { getTerminalPanelActions } from '@shared/lib/actions/terminal-actions'
import type { TableAction } from '@shared/types/data-table'

const actions = getTerminalPanelActions({}) as unknown as TableAction<TerminalInfo>[]

interface TerminalActionsProps {
  entityInfo: TerminalInfo
}

export function TerminalActionsComponent({ entityInfo }: TerminalActionsProps) {
  const primaryCTA = useMemo(() => {
    const status = entityInfo.status
    if (status === 'active') return { label: 'Restart terminal' }
    return null
  }, [entityInfo.status])

  return (
    <div className="flex items-center gap-2">
      {primaryCTA && (
        <Button
          variant="action"
          size="action"
          onClick={() => toast.info('Restart terminal initiated')}
        >
          {primaryCTA.label}
        </Button>
      )}
      <ActionDropdown actions={actions} item={entityInfo} variant="outline" />
    </div>
  )
}
